import { THEME } from '@anytag/shared-constants';
import { ListEmpty, RenderDataWithFallback } from '@anytag/shared-atoms';
import { cn, convertOrderToORDER, getValuableVariables } from '@anytag/shared-utils';
import { ReadPackageAccount, usePackageInfluencersQuery } from '@anytag/graphql';
import { useInfluencerPackagesContext } from '../InfluencerPackagesContext';
import { ProfileWidget } from './ProfileWidget';

export interface InfluencersListWidgetProps {
  packageAccount: ReadPackageAccount;
}

export const InfluencersListWidget = ({ packageAccount }: InfluencersListWidgetProps) => {
  const { sort, getInfluencersListSelectButtonProps } = useInfluencerPackagesContext();
  const { data, loading } = usePackageInfluencersQuery({
    skip: !packageAccount.accounts,
    fetchPolicy: 'cache-and-network',
    variables: getValuableVariables({
      packageId: packageAccount.id,
      orderBy: { field: sort.field, order: convertOrderToORDER(sort.order) }
    })
  });

  const influencers = data?.packageInfluencers || [];

  return (
    <RenderDataWithFallback
      loading={loading}
      hasNoData={!influencers.length}
      loadingProps={{ className: cn('h-50') }}
      noDataNode={<ListEmpty css={{ minHeight: '200px' }} hideDescription />}
      skipDelayed
    >
      <div css={{ padding: '16px', boxSizing: 'border-box', backgroundColor: THEME.background.colors.gray.lv2 }}>
        {influencers.map((influencer) => (
          <ProfileWidget
            profile={influencer}
            key={`package-${packageAccount.id}-influencer-${influencer.influencerId}`}
            selectButtonProps={getInfluencersListSelectButtonProps?.(packageAccount, influencer)}
          />
        ))}
      </div>
    </RenderDataWithFallback>
  );
};
